import { useDispatch, useSelector } from 'react-redux';
import { dashboardActions } from '../../../../../../store/slices/dashboardSlice/dashboardSlice';
import { useCallback } from 'react';

export const useNotGivenRow = () => {
    const dispatch = useDispatch();
    const { is_customer, can_show_financial_info } = useSelector(
        //@ts-ignore
        (state) => state.dashboardReducer
    );

    const onClickInformation = useCallback(() => {
        if (!is_customer && can_show_financial_info) {
            dispatch(dashboardActions.onModalMode('editInformation'));
        }
    }, []);

    return { onClickInformation, is_customer, can_show_financial_info };
};
